<i
  [ngClass]="{ fas: fas, far: far, fab: fab, fal: fal, fad: fad }"
  class="fa-{{ icon }} {{ class }} {{ classInside }} {{ sizeClass }}"
></i>
